// extracted by mini-css-extract-plugin
module.exports = {"lower":"lower__m6gNZ","upper":"upper__ej5XC","label":"label__3zYyv"};